export const getUserToken = () => {
    const user = localStorage.getItem("user");
    if (!user) return;
    const { token } = JSON.parse(user);
    return token;
}